export const permissions = {
  canCreateUser: "CAN_CREATE_USER",
  canUpdateUser: "CAN_UPDATE_USER",
  canQueryUser: "CAN_QUERY_USER",
  canQueryRoles: "CAN_QUERY_ROLES",
  canUpdateRole: "CAN_UPDATE_ROLE",
  canCreateRole: "CAN_CREATE_ROLE",
  canQueryPermissions: "CAN_QUERY_PERMISSIONS",
  canUnlockUser: "CAN_UNLOCK_USER",
  canRegisterTerminals: "CAN_REGISTER_TERMINALS",
  canFetchTerminals: "CAN_FETCH_TERMINALS",
  canUpdateTerminals: "CAN_UPDATE_TERMINALS",
  canAssignTerminals: "CAN_ASSIGN_TERMINALS",
  canRequestForTerminals: "CAN_REQUEST_FOR_TERMINALS",
  canFetchTerminalRequests: "CAN_FETCH_TERMINAL_REQUESTS",
  canAddAgentAccount: "CAN_ADD_AGENT_ACCOUNT",
  canFetchAgentAccounts: "CAN_FETCH_AGENT_ACCOUNTS",
  canCreateAgentPersonalDetails: "CAN_CREATE_AGENT_PERSONAL_DETAILS",
  canUpdateAgentPersonalDetails: "CAN_UPDATE_AGENT_PERSONAL_DETAILS",
  canCreateAgentsNextOfKinsDetails: "CAN_CREATE_AGENTS_NEXT_OF_KINS_DETAILS",
  canUpdateAgentsNextOfKinsDetails: "CAN_UPDATE_AGENTS_NEXT_OF_KINS_DETAILS",
  canFetchAgentsNextOfKinsDetails: "CAN_FETCH_AGENTS_NEXT_OF_KINS_DETAILS",
  canCreateAgentsGuarantorsDetails: "CAN_CREATE_AGENTS_GUARANTORS_DETAILS",
  canUpdateAgentsGuarantorsDetails: "CAN_UPDATE_AGENTS_GUARANTORS_DETAILS",
  canFetchAgentsGuarantorsDetails: "CAN_FETCH_AGENTS_GUARANTORS_DETAILS",
  canKYCDocumentsUpload: "CAN_KYC_DOCUMENTS_UPLOAD",
  canFetchKYCDocuments: "CAN_FETCH_KYC_DOCUMENTs",
  canFetchAgentDetails: "CAN_FETCH_AGENT_DETAILS",
  canUpdateAgentProfile: "CAN_UPDATE_AGENT_PROFILE",
  canMageAgentAggregatorRequest: "CAN_MAKE_AGENT_AGGREGATOR_REQUEST",
  canFetchPendingApprovals: "CAN_FETCH_PENDING_APPROVALS",
  canGiveApprovals: "CAN_GIVE_APPROVALS",
  canFetchPendingChanges: "CAN_FETCH_PENDING_CHANGES",
  canQueryEntityValues: "CAN_QUERY_ENTITY_VALUE",
  canGetCommisionStatistics: "CAN_GET_COMMISSION_STATISTICS",
  canGetTerminalStatistics: "CAN_GET_TERMINAL_STATISTICS",
  canGetTransactionStatistics: "CAN_GET_TRANSACTION_STATISTICS",
  canGetBasicStatistics: "CAN_GET_BASIC_STATISTICS",
  canGetAgentStatistics: "CAN_GET_AGENT_STATISTICS",
  canDownloadKYC: "CAN_DOWNLOAD_KYC",

  canUpdateAgent: "CAN_UPDATE_AGENT",

  //CONTROLS VIEWING RENDER
  canSeeApproveAgentAccount: "CAN_SEE_APPROVE_AGENT_ACCOUNT",
  canSeeApproveAgent: "CAN_SEE_APPROVE_AGENT",
  canSeeApproveAdminAccount: "CAN_SEE_APPROVE_ADMIN_ACCOUNT",
  canSeeApproveRoleAuthorization: "CAN_SEE_APPROVE_ROLE_AUTHORIZATION",
  canSeeApproveTerminalAuthorization: "CAN_SEE_APPROVE_TERMINAL_AUTHORIZATION",
  canSeeApproveTerminalMapping: "CAN_SEE_APPROVE_TERMINAL_MAPPING",
  canSeeUserManagementAdmin: "CAN_SEE_USER_MANAGEMENT_ADMIN", //See all admin users (For Admin)
  canSeeUserManagement: "CAN_SEE_USER_MANAGEMENT", //See all agents and aggregator users (For Admin)
  // canSeeAdminUserManagement: "CAN_SEE_ADMIN_USER_MANAGEMENT",
  canSeeRoleManagemnt: "CAN_SEE_ROLE_MANAGEMENT",
  canSeeTerminalRequests: "CAN_SEE_TERMINAL_REQUESTS",
  canSeeRegisterTerminals: "CAN_SEE_REGISTER_TERMINALS",
  canSeeManageTerminals: "CAN_SEE_MANAGE_TERMINALS",
  canSeeTerminals: "CAN_SEE_TERMINALS",
  canSeeAgentManagement: "CAN_SEE_AGENT_MANAGEMENTS", //See all aggregator owned agents (For aggregator)
  canSeeNotificationManagement: "CAN_SEE_MANAGE_NOTIFICATIONS",
  canSeeOnboardingStaistics: "CAN_SEE_ONBOARDING_STATISTICS",
  canSeeTerminalStaistics: "CAN_SEE_TERMINAL_STATISTICS",
  canSeeTransactionReport: "CAN_SEE_TRANSACTION_REPORT",

  canSeeApprovePmAccount: "CAN_SEE_APPROVE_PM_ACCOUNT",
  canSeeApprovePmAccountLevelOne: "CAN_SEE_PM_ACCOUNT_ADDED_LEVEL_1",
  canSeeApprovePmAccountLevelTwo: "CAN_SEE_PM_ACCOUNT_ADDED_LEVEL_2",
};
